<button class="preset-mark" (click)="click()" [class.clickable]="formModel.hasInfotext() && noClick === false" *ngIf="formModel.getPresetMark()" [title]="'input.presetted' | translate"><i class="icon-robot"></i></button>
